import { render, staticRenderFns } from "./OrderListDeliverySuccess.vue?vue&type=template&id=6a8a6219&scoped=true"
import script from "./OrderListDeliverySuccess.vue?vue&type=script&lang=js"
export * from "./OrderListDeliverySuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliverySuccess.vue?vue&type=style&index=0&id=6a8a6219&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a6219",
  null
  
)

export default component.exports